import React, { FC, useState, useCallback, useRef, useEffect } from "react"
import { observer } from "mobx-react-lite"
import { ViewStyle, View, Appearance } from "react-native"
import { Screen, Button, SecondPriceForm } from "../../../../components"
// import { useStores } from "../../models"
import { color } from "../../../../theme"
import { useStores } from "../../../../models"
import { FormikProps, FormikValues } from "formik"
import { navigate } from "../../../../navigators"
import { CompositeScreenProps } from "@react-navigation/native"
import { delay } from "../../../../utils/delay"
import { ShrimpPrice } from "../../../../database"
import SyncableModel from "../../../../database/SyncableModel"
import JalaAnalytic from "../../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  backgroundColor: color.palette.white,
  flexGrow: 1,
  // paddingHorizontal: 16,
  paddingTop: 23
}

const BUTTON_CONTAINER: ViewStyle = {
  paddingVertical: 8,
  paddingHorizontal: 16,
  flex: 1,
  justifyContent: 'flex-end',
}

export const CreateShrimpPriceSecondScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function CreateShrimpPriceFirstScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params } } = props
  const { shrimpPriceStore, shrimpPriceStore: { shrimpPrice }, userStore: { user } } = useStores()
  const [ loading, setLoading ] = useState<boolean>(false)
  const [ isError, setIsError ] = useState<boolean>(true);
  const [ model, setModel ] = useState<SyncableModel>(null)

  useEffect(() => {
    if (shrimpPrice) {
        JalaAnalytic.log('Mobile app: visit form shrimp price - edit', user);
        const model = ShrimpPrice.hydrate({...shrimpPrice});
        setModel(model);
    }
  }, [shrimpPrice, user])

  const priceForm = useRef<FormikProps<FormikValues>>()
  const priceFormRef = useCallback((node) => {
    priceForm.current = node;
    if (priceForm.current) setIsError(!(priceForm.current.dirty && priceForm.current.isValid))
  }, [])

  const onSubmit = async (data) => {
    setLoading(true)
    if (data.created_at) {
      await shrimpPriceStore.update(model, data)
    }
    else if (data.region_ids.length)
      for (let i = 0; i < data.region_ids.length; i++) {
        await shrimpPriceStore.store({ ...data, region_id: data.region_ids[i] });
      }
    else {
      await shrimpPriceStore.store({ ...data });
    }
    setLoading(false)
    await delay(1);
    navigate('Home.Stack', 'Home.ShrimpPrice.List');
  }

  const handleSubmit = (event) => {
    if (priceForm.current) priceForm.current.handleSubmit(event)
    // if (planktonForm.current) planktonForm.current.handleSubmit(event)
  }
  // Pull in one of our MST stores
  // const { someStore, anotherStore } = useStores()
  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
    >
      <SecondPriceForm
        colorScheme={colorScheme}
        initialValues={params}
        innerRef={priceFormRef}
        onSubmit={onSubmit}
      />
      <View style={BUTTON_CONTAINER}>
        <Button
          testID="jala:id/save-button"
          tx="shrimpPriceScreen.save"
          colorScheme={colorScheme}
          loading={loading}
          disabled={isError}
          onPress={handleSubmit}
        />
      </View>
    </Screen>
  )
})
